import { memo } from 'react';
import { Badge } from '@bbpos/ui';
import { ACCOUNT_STATUS_BADGE } from './status';
import type { AccountStatus } from './types';

export const AccountStatusPill = memo(function AccountStatusPill({
  status,
}: {
  status: AccountStatus;
}) {
  const meta = ACCOUNT_STATUS_BADGE[status] ?? ACCOUNT_STATUS_BADGE.ACTIVE;
  return (
    <Badge variant={meta.variant} size="sm" dot>
      {meta.label}
    </Badge>
  );
});
